// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"281":"4556f9f1","389":"520828ca"}[chunkId] + ".css";
};